<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Тоног төхөөрөмж / Камер" />
    <div class="content-body">
        <div class="container pd-0-f">
            <div class="row row-xs">
                <div class="col-md-6 col-xl-4 order-md-1 order-xl-0 pd-t-0-f">
                    <div class="card ht-lg-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                  <h6 class="mg-b-0">Зөрчил илрүүлэлт</h6>
                  <div class="tx-13 d-flex align-items-center">
                    TOP 5
                  </div>
                </div><!-- card-header -->
                <div class="card-body pd-0">
                  <div class="pd-y-25 pd-x-20">
                    <apexchart :options="chartOptions" :series="series"></apexchart>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-borderless table-dashboard table-dashboard-one">
                      <thead class="bd-b">
                        <tr>
                          <th class="wd-40">Камер</th>
                          <th class="wd-35 text-right">Зөрчил</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                        <tr>
                          <td class="tx-medium">Баруун 4 зам /зүүнээс баруун/</td>
                          <td class="text-right">150,200</td>
                        </tr>
                      </tbody>
                    </table>
                  </div><!-- table-responsive -->
                </div><!-- card-body -->
              </div>
                </div>
                <div class="col-lg-12 col-xl-8 pd-t-0-f">

                    <div class="card mg-b-10">
                <div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                  <div>
                    <h6 class="mg-b-5">Камераар илрүүлсэн зөрчлийн онцлох үзүүлэлтүүд</h6>
                    <p class="tx-13 tx-color-03 mg-b-0">Your sales and referral earnings over the last 30 days</p>
                  </div>
                  <div class="d-flex mg-t-20 mg-sm-t-0">
                    <!-- <div class="btn-group flex-fill">
                      <button class="btn btn-white btn-xs active">Range</button>
                      <button class="btn btn-white btn-xs">Period</button>
                    </div> -->
                  </div>
                </div><!-- card-header -->
                <div class="card-body pd-y-30">
                  <div class="d-sm-flex">
                    <div class="media">
                      <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-teal tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                      </div>
                      <div class="media-body">
                        <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Өдөрт</h6>
                        <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">$1,958,104</h4>
                      </div>
                    </div>
                    <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                      <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                      </div>
                      <div class="media-body">
                        <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">7 хоногт</h6>
                        <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">$234,769<small>.50</small></h4>
                      </div>
                    </div>
                    <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                      <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bar-chart-2"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                      </div>
                      <div class="media-body">
                        <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Сард</h6>
                        <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">$1,608,469<small>.50</small></h4>
                      </div>
                    </div>
                  </div>
                </div><!-- card-body -->
                <div class="table-responsive">
                  <table class="table table-dashboard mg-b-0">
                    <thead>
                      <tr>
                        <th>Огноо</th>
                        <th class="text-right">Хурд</th>
                        <th class="text-right">Улсын дугаар</th>
                        <th class="text-right">Марк, Модел</th>
                        <th class="text-right">Өнгө</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="tx-color-03 tx-normal">03/08/2020</td>
                        <td class="tx-medium tx-pink text-right">103</td>
                        <td class="text-right">0000 УУУУ</td>
                        <td class="text-right">Toyota, Prius</td>
                        <td class="tx-medium text-right">Саарал</td>
                      </tr>
                    </tbody>
                  </table>
                </div><!-- table-responsive -->
              </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import VueApexCharts from "vue-apexcharts";

export default {
  components:{
    apexchart: VueApexCharts,
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data(){
    return{
      chartKey: 0,
      series: [44, 55, 13, 43, 22],
        chartOptions: {
            legend:{
                show: false,
            },
        chart: {
            type: 'pie',
        },
        labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
        responsive: [{
            breakpoint: 480,
            options: {
            chart: {
                width: 200
            },
            legend: {
                position: 'bottom'
            }
            }
        }]
        },
    }
  }
}
</script>

<style>

</style>